import { httpService } from '../../../http-service/httpService';
import {
  CAMPAIGN_TYPES,
  PERSONALIZATION_ALERTS,
  VIEW_OPTIONS,
} from '../../../utils/constant';
import {
  CLEAR_CURRENT_PERSONALIZATION,
  PERSONALIZATION_ALL,
  PERSONALIZATION_SET_DEFAULT_VIEW,
  PERSONALIZATION_VIEW_OPTION,
  SET_ALL_CAMPAIGN_PERSONALIZATION_DATA,
  SET_PERSONALIZATION,
  SET_PERSONALIZATION_STATUS,
  UPDATE_PERSONALIZATION_API_STATUS,
} from '../types';
import {
  URL_CREATE_PERSONALIZATION_API,
  URL_GET_PERSONALIZATION_API,
  URL_UPDATE_PERSONALIZATION_API,
} from '../urls';

export const setPersonalizationStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_PERSONALIZATION_STATUS,
    payload: status,
  });
};

export const setPersonalizationViewOption = (payload) => (dispatch) => {
  dispatch({
    type: PERSONALIZATION_VIEW_OPTION,
    payload,
  });
};

export const setTriggerForUserDefaultView = (status) => (dispatch) => {
  dispatch({
    type: PERSONALIZATION_SET_DEFAULT_VIEW,
    payload: status,
  });
};

export const clearCurrentPersonalization = (flag) => (dispatch) => {
  dispatch({
    type: CLEAR_CURRENT_PERSONALIZATION,
    payload: flag,
  });
};

export const updatePersonalizationAll = (payload) => (dispatch) => {
  dispatch({
    type: PERSONALIZATION_ALL,
    payload,
  });
};

export const updatePersonalizationApiStatusAction = (payload) => (dispatch) => {
  dispatch({
    type: UPDATE_PERSONALIZATION_API_STATUS,
    payload,
  });
};

export const getPersonalization = () => async (dispatch, getState) => {
  try {
    const {
      core: { campaignType },
    } = getState().certifications.details;
    const { data } = await httpService.post(URL_GET_PERSONALIZATION_API);

    const status =
      data.response === 'No View Found'
        ? 'NO_PERSONALIZATION'
        : 'EXIST_PERSONALIZATION';

    dispatch(
      setPersonalizationViewOption({
        view: VIEW_OPTIONS.MY_PERSONALIZED_VIEW,
        applied: true,
      })
    );

    /// when no data found
    if (data.response === 'No View Found') {
      dispatch({
        type: SET_PERSONALIZATION,
        payload: data,
      });
    } else {
      // set individual campaign personalization to redux
      const dataToBeUpdated = JSON.parse(JSON.stringify(data));

      if (dataToBeUpdated?.result?.info) {
        const campaignPersonalizaion =
          dataToBeUpdated?.result?.info[CAMPAIGN_TYPES[campaignType]];

        dataToBeUpdated.result.info = campaignPersonalizaion || {};

        dispatch({
          type: SET_PERSONALIZATION,
          payload: dataToBeUpdated,
        });
      }
    }

    dispatch(setPersonalizationStatus(status));

    // set personalization to redux
    if (data?.result?.info) {
      dispatch({
        type: SET_ALL_CAMPAIGN_PERSONALIZATION_DATA,
        payload: data.result.info,
      });
    }
  } catch (error) {
    dispatch(
      setPersonalizationViewOption({
        view: VIEW_OPTIONS.DEFAULT_VIEW,
        applied: false,
      })
    );

    dispatch(setPersonalizationStatus(''));
    dispatch({
      type: SET_PERSONALIZATION,
      payload: {},
    });
  }
};

export const createPersonalization =
  (payload) => async (dispatch, getState) => {
    const {
      core: { campaignType },
      global: { certKey },
    } = getState().certifications.details;

    //  to update the individual campaign personalization
    const campaignKey = CAMPAIGN_TYPES[campaignType];

    const body = { certkey: certKey, [campaignKey]: payload };

    try {
      await httpService.post(URL_CREATE_PERSONALIZATION_API, body);

      dispatch(
        updatePersonalizationApiStatusAction(
          PERSONALIZATION_ALERTS.CREATE_SUCCESS
        )
      );
      dispatch(getPersonalization());
    } catch (error) {
      dispatch(
        updatePersonalizationApiStatusAction(
          PERSONALIZATION_ALERTS.CREATE_FAILED
        )
      );
      dispatch(setPersonalizationStatus(''));
      dispatch(clearCurrentPersonalization(true));
    }
  };

export const updatePersonalization =
  (payload, eTag) => async (dispatch, getState) => {
    try {
      const {
        core: { campaignType },
        personalization: { campaignPersonalizationData },
      } = getState().certifications.details;

      const config = { headers: { 'If-Match': `${eTag}` } };

      //  to update the individual campaign personalization
      const campaignKey = CAMPAIGN_TYPES[campaignType];
      const updatePersonalizationData = campaignPersonalizationData;

      if (campaignKey && updatePersonalizationData) {
        updatePersonalizationData[campaignKey] = payload;
      }

      const body = updatePersonalizationData;

      await httpService.post(URL_UPDATE_PERSONALIZATION_API, body, config);
      dispatch(
        updatePersonalizationApiStatusAction(
          PERSONALIZATION_ALERTS.UPDATE_SUCCESS
        )
      );
      dispatch(getPersonalization());
    } catch (error) {
      if (error?.response?.data?.response === 'invalidLength') {
        dispatch(
          updatePersonalizationApiStatusAction(
            PERSONALIZATION_ALERTS.UPDATE_FAILED_INVALID_LENGTH
          )
        );
      } else {
        dispatch(
          updatePersonalizationApiStatusAction(
            PERSONALIZATION_ALERTS.UPDATE_FAILED
          )
        );
      }

      dispatch(setPersonalizationStatus('UPDATE_PERSONALIZATION_FAILED'));
    }
  };
